/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 */

import React from 'react';
import './institution.css';
import Table from "../../components/generic/table/table";

import tableConfigs from "../../components/generic/table/tableConfigs";
import EventEmitter from "../../eventEmmiters/EventEmitter";

// get table configurations
const table = tableConfigs.institutionUrl;

class InstitutionUrls extends React.Component {
    constructor(props) {
        super(props);
        EventEmitter.emit('setPageHeaderData', {
            page: 'institutionUrls',
            pageName: "Institution Urls",
            pageLink: process.env.REACT_APP_BASE_URL + "/#/home/institutionUrls",
            optionalIcons: ['manageColumnsIcon']
        });
    }

    render() {
        return(
            <div className={'page-mainLayout'}>
                <Table tableConfig={table} routerProps={this.props}/>
                <div className="main-btn-container">
                    <div className="buttons" tooltip="Add Partner"
                         onClick={() => this.props.history.push('/home/institutionUrls/create')}>
                        <i className="fa fa-plus fa-lg icon-primary" />
                    </div>
                </div>
            </div>
        )
    }
}

export default InstitutionUrls;
